import { render, staticRenderFns } from "./guarantydetails.vue?vue&type=template&id=cdb4fffa&scoped=true&"
import script from "./guarantydetails.vue?vue&type=script&lang=js&"
export * from "./guarantydetails.vue?vue&type=script&lang=js&"
import style0 from "./guarantydetails.vue?vue&type=style&index=0&id=cdb4fffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdb4fffa",
  null
  
)

export default component.exports